import React from 'react'
import './error404.css'

function Error404() {
  return (
    <div>

      <div className='error-message'>
        <p>Error 404 - Ha ocurrido un problema</p>
        <p className='strong'>La pagina que estas intentando acceder no se encuentra disponible</p>
      </div>

      <div className='error-img'>

      </div>
    </div>
  )
}

export default Error404